// Centralized API URL config
// ALWAYS use relative paths — both preview (K8s ingress) and production (nginx)
// route /api to the backend. No env var needed, no URL to leak.
export const API_URL = '';
